var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('div',{staticStyle:{"height":"20px"}}),_c('Title'),_c('HomeTask')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }